var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export default styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%; \n  ", "\n"], ["\n  display: inline-block;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%; \n  ", "\n"])), function (_a) {
    var color = _a.color;
    return color && "background-color: " + color + ";";
});
var templateObject_1;
